import $ from 'jquery'
import _ from 'lodash'
import adminConnectionsRow from './admin-connections-row.hbs'
import appDisplay from 'scoreboard/components/app-display'
import DraggableList from 'draggable-list'
import ErrorView from 'scoreboard/components/error-view'
import AdminPanels from 'scoreboard/admin/admin-panels'
import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import i18n from 'scoreboard/components/i18n'

/**
 * Base view for Scoreboard Databases (admin-impact-databases.js) and
 * Import Connections (admin-import-connections.js) screens
 */
var AdminConnections = AdminPanels.extend({

	// this.collection is a plain JavaScript array holding the connections
	// this.Model is the model for the connection

	rowTemplate: adminConnectionsRow,
	titleDescKeyPrefix: 'admin.importConnections.',
	addButtonLabel: 'admin.databaseConnections.action.add',

	events: _.extend({}, AdminPanels.prototype.events, {
		// disable or enable a database
		'click .toggle-connection': 'toggle',
		'click .error-details': 'errorDetails'
	}),

	renderPanel: function(type) {
		let panel = AdminPanels.prototype.renderPanel.apply(this, arguments)
		let draggableList = new DraggableList(panel.find('ul.list')[0])
		draggableList.on('move', this.reorder.bind(this))
		this.draggableLists.push(draggableList)
		panel.addClass('has-draggable-list')

		new TooltipAndDetails({
			tooltipOptions: {
				extraClass: 'tooltip-body-only'
			},
			el: this.el,
			selector: '[data-database-id]',
			tooltipContent: e => {
				return `<span class="highlight">${i18n.get('common.id')}:</span> ${e.target.dataset.databaseId}`
			}
		})
		return panel
	},

	rowContext: function(connection) {
		let online = connection.status === 'online'
		var toggleAction = connection.status === 'disabled' ? 'enable' : 'disable'
		toggleAction = 'admin.databaseConnections.action.' + toggleAction
		var toggleIcon = connection.status === 'disabled' ? 'on-off' : 'not-allowed'
		var rebuildIndexes = connection.type === 'scoreboard'
		let owners = this.getOwnerHtml(connection.owners)
		let editable = _.isNil(connection.editable) ? true : connection.editable
		if (connection.type === 'web-service') {
			connection.icon = 'webservice'
		}
		return _.extend({}, connection,
			{ online, toggleAction, toggleIcon, owners, rebuildIndexes, editable })
	},

	errorDetails: function(e) {
		var id = this._itemId(e)
		var connection = this._item(id)
		// the connection has the message and stackTrace properties the
		// ErrorView already expects
		appDisplay.dialog(new ErrorView(connection))
	},

	toggle(e) {
		var id = this._itemId(e)
		var connection = this._item(id)
		var action = connection.status === 'disabled' ? 'enable' : 'disable'
		$.post(`${this.urlRoot}/${id}/${action}`, revised => {
			_.extend(connection, revised)
			this.render()
		})
	}
})

export default AdminConnections

AdminConnections.__filename__ = 'admin/connections/admin-connections.js'
